import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useCallback } from 'react';
import {
  TrackedEvent,
  useTrackedEventDataContext,
} from '@higo/common/lib/features/TrackedEvent';

export const useDispatchMicrositeTrackedEvent = () => {
  const sendDataToGTM = useGTMDispatch();
  const trackedCustomEventContextData = useTrackedEventDataContext();

  return useCallback(
    (event: TrackedEvent) => {
      sendDataToGTM({
        ...trackedCustomEventContextData,
        ...event,
      });
    },
    [sendDataToGTM, trackedCustomEventContextData],
  );
};
